import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@angular/flex-layout';
import { EmailEditorModule } from 'angular-email-editor';
import { TemplateListComponent } from './template-list/template-list.component';
import { TemplateEditorComponent } from './template-editor/template-editor.component';
import { EmailDesignerComponent } from './email-designer/email-designer.component';
import { TemplatePreviewComponent } from './template-preview/template-preview.component';
import { VariableChipsComponent } from './variable-chips/variable-chips.component';
import { UnsavedChangesGuard } from './unsaved-changes.guard';

const routes: Routes = [
    {
        path: '', component: TemplateListComponent
    },
    {
        path: 'edit/:templateKey', component: TemplateEditorComponent,
        canDeactivate: [UnsavedChangesGuard]
    }
];

@NgModule({
    declarations: [
        TemplateListComponent,
        TemplateEditorComponent,
        EmailDesignerComponent,
        TemplatePreviewComponent,
        VariableChipsComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        FlexLayoutModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatSlideToggleModule,
        MatTableModule,
        MatTooltipModule,
        EmailEditorModule,
        RouterModule.forChild(routes),
    ]
})
export class EmailTemplatesModule { }
